export default __webpack_public_path__ + "static/intro-da61a3220c4e2529d5b87219f6d9b20f.mp4";